export default {
  de: {
    required: '*Pflichtfeld',
    name: 'Name',
    password: 'Passwort',
    value: 'Wert',
    iso: 'ISO',
    code: 'Code',
    amaId: 'AMA ID',
    zip: 'PLZ',
    phoneCode: 'Vorwahl',
    percentValue: 'Prozentsatz',
    description: 'Beschreibung',
    days: 'Tage',
    firstName: 'Vorname',
    lastName: 'Nachname',
    salutation: 'Anrede',
    title: 'Titel',
    email: 'E-Mail',
    mobilePhone: 'Mobiltelefon',
    phone: 'Telefon',
    place: 'Ort',
    country: 'Land',
    street: 'Straße',
    contact: {
      type: 'Typ',
      value: 'Wert',
      default: 'Standard',
      comment: 'Kommentar'
    },
    factoryDetail: {
      lfbis: 'LFBIS',
      ringNr: 'Ring-Nr',
      name: 'Betriebsname'
    },
    pigSty: {
      name: 'Name',
      veterinarian: 'Tierarzt',
      businessMode: 'Betriebsart',
      productionSpaces: 'Einstellplätze',
      options: {
        caption: 'Eigenschaften',
        tgd: 'TGD Mitglied',
        ama: 'AMA Gütesiegek',
        piglet: 'Ferkellieferung',
        babyPiglet: 'Babyferkellieferung',
        pcv2: 'PCV2'
      }
    },
    article: {
      group: {
        name: 'Name'
      }
    },
    addition: {
      from: 'von',
      to: 'bis',
      amount: 'Zu- Abschlag Betrieb',
      amountSlaughter: 'Zu- Abschlag Schlachthof',
      type: 'Aufschlagsvariante'
    }
  }
}
